import { useState } from 'react';
import DateTimePicker from 'react-datetime-picker';

function WheelDateTimePicker({ itemKey, initialValue, update, extra }) {
	const [value, setValue] = useState(initialValue?new Date(initialValue):null);
	const setDate = (newValue) => {
		setValue(newValue);
		update(itemKey, newValue?newValue.getTime():null, extra)
	}
	return (
		<div className="datepicker__sm">
			<DateTimePicker onChange={setDate} value={value} locale="en-GB"/>
		</div>
	);
}

export default WheelDateTimePicker;
